module.exports = __webpack_public_path__ + "img/meigui.e10b45a2.png";